
import { useState } from 'react'
import { ChatBubbleOvalLeftEllipsisIcon, EnvelopeIcon } from '@heroicons/react/20/solid'

function classNames(...classes) {
  return classes.filter(Boolean).join(' ')
}

export default function Contact() {

  return (
    <div className="isolate bg-white px-6 py-24 sm:py-32 lg:px-8">
      <div className="mx-auto max-w-2xl text-center">
        <h2 className="text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">Besoin d'informations supplémentaires ou d'une assistance personnalisée ?</h2>
        <p className="mt-2 text-lg leading-8 text-gray-600">
         N'hésitez pas à nous contacter. Notre équipe dévouée est là pour répondre à toutes vos questions et vous
          guider dans votre démarche vers une mode plus responsable.
        </p>
        <div className='mx-auto max-w-lg grid grid-cols-2 gap-x-4 py-4'>
            <a data-aos="flip-left" href='mailto:rosykaduku4@gmail.com"' className='flex items-center justify-center space-x-2 bg-gray-300 hover:bg-gray-900 shadow rounded-full py-2 px-2'>
              <EnvelopeIcon className='w-10 text-white'/>
              <p className=' font-medium text-white'>E-mail</p>
            </a>
            <a data-aos="flip-left" href='https://wa.me/+243977478442' className='flex items-center justify-center space-x-2 bg-gray-300 hover:bg-gray-900 shadow rounded-full py-2 px-2'>
                <ChatBubbleOvalLeftEllipsisIcon className='w-10 text-white'/>
                <p className=' font-medium text-white'>Whatsapp</p>
            </a>
        </div>
      </div>
      <form  className="mx-auto mt-12 max-w-xl sm:mt-12">
        <div className="grid grid-cols-1 gap-x-8 gap-y-6 sm:grid-cols-2">
          <div>
            <label htmlFor="first-name" className="block text-sm font-semibold leading-6 text-gray-900">
              Nom
            </label>
            <div className="mt-2.5">
              <input
                type="text"
                name="first-name"
                id="first-name"
                placeholder='Entrez votre nom'
                autoComplete="given-name"
                className="block w-full rounded-md border-0 px-3.5 py-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-gray-700 sm:text-sm sm:leading-6"
              />
            </div>
          </div>
          <div>
            <label htmlFor="last-name" className="block text-sm font-semibold leading-6 text-gray-900">
              Prénom
            </label>
            <div className="mt-2.5">
              <input
                type="text"
                name="last-name"
                id="last-name"
                placeholder='Entrez votre prénom'
                autoComplete="family-name"
                className="block w-full rounded-md border-0 px-3.5 py-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-gray-700 sm:text-sm sm:leading-6"
              />
            </div>
          </div>
          <div className="sm:col-span-2">
            <label htmlFor="email" className="block text-sm font-semibold leading-6 text-gray-900">
              E-mail
            </label>
            <div className="mt-2.5">
              <input
                type="email"
                name="email"
                id="email"
                placeholder='Entrez votre e-mail'
                autoComplete="email"
                className="block w-full rounded-md border-0 px-3.5 py-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-gray-700 sm:text-sm sm:leading-6"
              />
            </div>
          </div>
          <div className="sm:col-span-2">
            <label htmlFor="message" className="block text-sm font-semibold leading-6 text-gray-900">
              Message
            </label>
            <div className="mt-2.5">
              <textarea
                name="message"
                id="message"
                placeholder='Votre message ici'
                rows={4}
                className="block w-full rounded-md border-0 px-3.5 py-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-gray-700 sm:text-sm sm:leading-6"
                defaultValue={''}
              />
            </div>
          </div>
        </div>
        <div className="mt-10">
          <button
            type="submit"
            className="block w-full rounded-md bg-black px-3.5 py-2.5 text-center text-base font-semibold text-white shadow-sm hover:bg-gray-700 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gray-700"
          >
            Envoyer votre message
          </button>
        </div>
      </form>
    </div>
  )
}
